import { splitPathParts } from './splitPathParts.js';

export const getDeep = (str, data) => {
  if (str === '') {
    return data;
  }

  const cleanStr = str?.replace(/\?./g, '.');
  const parts = splitPathParts(cleanStr);

  let runningObject = data;

  if (runningObject === null || runningObject === undefined) {
    return undefined;
  }

  for (let i = 0; i < parts.length; ++i) {
    let key = parts[i];
    let filterParts;
    const matchBrackets = key?.match(/\[.*?\]/g);
    const matchBracketsAndQuotes = key?.match(/\[".*?"\]/g);

    if (runningObject === null || runningObject === undefined) {
      return undefined;
    }

    if (matchBrackets && !matchBracketsAndQuotes) {
      const parts = key.split('[');
      key = parts[0];
      filterParts = parts[1].replace(']', '').split(':');
    }

    if (matchBrackets && matchBracketsAndQuotes) {
      key = key.replace('["', '').replace('"]', '');
    }

    if (Array.isArray(runningObject[key]) && filterParts?.length === 1) {
      // This means we're accessing an array by index
      const filterValue = filterParts[0];
      const match = runningObject[key][filterValue];
      if (match === undefined) {
        return undefined;
      } else {
        runningObject = match;
      }
      continue;
    }

    if (Array.isArray(runningObject[key]) && filterParts?.length > 1) {
      const filterKey = filterParts[0];
      const filterValue = filterParts[1];
      const match = runningObject[key].find((n) => n[filterKey] === filterValue);
      if (match === undefined) {
        return undefined;
      } else {
        runningObject = match;
      }
      continue;
    }

    runningObject = runningObject[key];
  }

  return runningObject;
};
